/**
 * Build a cache-busted photo URL.
 *
 * SQLite reuses INTEGER PRIMARY KEY values when rows are deleted, so two
 * different photos can end up with the same id. Without cache-busting,
 * browsers serve week-old bytes from a deleted photo when a new upload
 * inherits the same id.
 *
 * Using both rotation_version (incremented on in-place rotation) and
 * created_at (unique per insert even if the id is reused) gives a URL
 * that changes whenever the underlying photo bytes change.
 */
export function photoUrl(id, rotationVersion = 0, createdAt = '') {
  if (!id) return null;
  const v = rotationVersion || 0;
  const t = encodeURIComponent(createdAt || '');
  return `/photos/${id}/file?v=${v}&t=${t}`;
}
